import React from 'react';

/**
 * ConversionHeroResults
 *
 * Props:
 * - energyBaseline: object containing baseline info (facilitySize, etc.)
 * - conservative: conservative annual savings number
 * - aggressive: aggressive annual savings number
 * - paybackMonths: ROI payback period in months
 */
const ConversionHeroResults = ({
  energyBaseline,
  conservative,
  aggressive,
  paybackMonths
}) => {
  return (
    <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-2xl p-8 text-white mb-8">
      <div className="text-center">
        <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-10 h-10 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        <h1 className="text-4xl font-bold mb-4">Assessment Complete!</h1>
        <p className="text-xl mb-4 text-emerald-100">
          Based on your{' '}
          {energyBaseline.facilitySize
            ? `${Number(energyBaseline.facilitySize).toLocaleString()} sq ft`
            : ''}{' '}
          facility, we've identified significant energy savings opportunities
        </p>

        <div className="bg-white bg-opacity-20 rounded-xl p-4 mb-8 max-w-2xl mx-auto">
          <p className="text-emerald-100 text-lg">
            <strong>Based on your assessment responses:</strong> $
            {aggressive.toLocaleString()}+ potential annual savings identified.
            <span className="text-white font-bold text-xl">
              {' '}
              Professional report pays for itself in under {paybackMonths} months.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white bg-opacity-10 rounded-xl p-6">
            <div className="text-3xl font-bold text-white">
              ${conservative.toLocaleString()}
            </div>
            <div className="text-emerald-100">Conservative Annual Savings</div>
          </div>
          <div className="bg-white bg-opacity-20 rounded-xl p-6 ring-2 ring-white ring-opacity-50">
            <div className="text-4xl font-bold text-white">
              ${aggressive.toLocaleString()}
            </div>
            <div className="text-emerald-100">Potential Annual Savings</div>
            <div className="text-xs text-emerald-200 mt-1">Most likely scenario</div>
          </div>
          <div className="bg-white bg-opacity-10 rounded-xl p-6">
            <div className="text-3xl font-bold text-white">{paybackMonths} months</div>
            <div className="text-emerald-100">Report ROI Payback</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversionHeroResults;


